import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

const POLYMARKET_BASE_PATH = '/polymarket'

export const getEventsService = (params) => axiosInstance(
  METHOD_TYPES.get,
  `${POLYMARKET_BASE_PATH}/get-events`,
  {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.table, params }
)
